"use client"

import { Icon, Link, type LinkProps } from "@chakra-ui/react"
import React from "react"

import NextLink from "@/components/RouteTransitionLink"

export interface LogoProps {
  size?: number | string
  props?: LinkProps
  alt?: string
  color?: string
  className?: string
}

const Logo: React.FC<LogoProps> = ({
  alt = undefined,
  className = undefined,
  color = "",
  props = undefined,
  size = 0,
}) => {
  return (
    <Link
      aria-label="Logo and link to Home page"
      asChild
      backgroundSize="0% 0px"
      color="primary.600"
      cursor="pointer"
      data-umami-event={"logo"}
      display="inline-flex"
      flexShrink={0}
      outlineColor={"primary.400"}
      {...props}
    >
      <NextLink href="/" transitionTypes={["nav-back"]}>
        <Icon
          aria-hidden={true}
          as="svg"
          className={className}
          focusable={false}
          height={size}
          pointerEvents="none"
          viewBox="0 0 256 256"
          width={size}
        >
          <title>{alt}</title>
          <path
            d="M200 129a72 72 0 01-72 71h-1v56h1a128 128 0 00128-127z"
            fill={"" == color ? "#4C40F7" : "currentColor"}
          />
          <path
            d="M247 157l9-28v-28H127v56h120z"
            fill={"" == color ? "#4C40F7" : "currentColor"}
          />
          <path
            d="M56 128a72 72 0 0171-72V0A128 128 0 000 128v1h56v-1z"
            fill={"" == color ? "#FF6800" : "currentColor"}
          />
        </Icon>
      </NextLink>
    </Link>
  )
}

export default Logo
